import {
  restaurant,
  shoppingBags,
  medical,
  car,
  transport,
  fun,
  other,
} from "assets/images";

const data = [
  { name: "restaurants", src: restaurant },
  { name: "medical", src: medical },
  { name: "shops", src: shoppingBags },
  { name: "car", src: car },
  { name: "transport", src: transport },
  { name: "fun", src: fun },
  { name: "other", src: other },
];
export default data;
